import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/streamer_concept.png")